/* =====================================================================
   CIMAFER · dataLayer (GA4 e-commerce via GTM)
   Empurra eventos de e-commerce do storefront pro dataLayer do GTM.
   Cobre: add_to_cart, view_cart, begin_checkout, remove_from_cart.
   Fonte de verdade dos itens: /cart.js e a resposta de /cart/add.js.
   OBS: o evento `purchase` acontece no checkout hospedado (fora do tema)
   e deve ser configurado via Customer Events / GTM no Admin.
   ===================================================================== */
(function () {
  window.dataLayer = window.dataLayer || [];
  var CURRENCY = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'BRL';

  function money(cents) {
    if (cents == null) return undefined;
    return Math.round(cents) / 100;
  }

  // Mapeia uma linha do carrinho (/cart.js ou /cart/add.js) pro item GA4.
  function toItem(line, index) {
    var variant = line.variant_title;
    if (variant === 'Default Title') variant = undefined;
    return {
      // item_id = content_id do feed/tags (shopify_ZZ_<pid>_<vid>); SKU vira campo secundario
      item_id: (line.product_id && line.variant_id) ? ('shopify_ZZ_' + line.product_id + '_' + line.variant_id) : String(line.sku || line.product_id || line.id || ''),
      sku: line.sku ? String(line.sku) : undefined,
      item_name: line.product_title || line.title || '',
      item_brand: line.vendor || undefined,
      item_variant: variant || undefined,
      price: money(line.final_price != null ? line.final_price : line.price),
      quantity: line.quantity || 1,
      index: index
    };
  }

  // Limpa o ecommerce anterior (boa prática GA4) e empurra o evento.
  function push(event, items, value) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: event,
      ecommerce: { currency: CURRENCY, value: value, items: items }
    });
  }

  // ── view_shipping_info (evento CUSTOM, não-padrão GA4) ──────────────
  // Disparado em QUALQUER ponto de cálculo de frete (PDP, Sacola/drawer, /cart).
  // MODO: 1 evento POR OPÇÃO de frete (flat, GA4-nativo). Cada opção = 1 push.
  // info: { zip, uf, city, bairro, rates:[{name,price,source}] } — price em
  // unidades major (ex.: "19.90"). Região sem cobertura → 1 evento sem_opcao.
  function shippingType(name, source) {
    // Classifica pelo NOME primeiro: o `source` de TODA rate é o carrier agregador
    // ("Cimafer · Grande POA") — até 01/out o SEDEX virava entrega_local_poa por isso.
    var n = (name || '').toLowerCase();
    if (/retir|pickup|balc|na loja/.test(n)) return 'retirada_loja';
    if (/sedex|\bpac\b|correio/.test(n)) return 'correios';
    if (/uber|expressa/.test(n)) return 'entrega_expressa';
    if (/grande poa|\bpoa\b|cimafer|entrega local|grandes cargas|frete gr/.test(n)) return 'entrega_local_poa';
    var s = (source || '').toLowerCase();
    if (/sedex|\bpac\b|correio/.test(s)) return 'correios';
    if (/grande poa|cimafer/.test(s)) return 'entrega_local_poa';
    return 'transportadora';
  }
  function _merge(a, b) { var o = {}, k; for (k in a) o[k] = a[k]; for (k in b) o[k] = b[k]; return o; }
  var _shipSig = '', _shipT = 0;
  window.cimaShippingInfo = function (info) {
    if (!info || !info.zip) return;                 // sem CEP → nada
    var rates = (info.rates || []).filter(function (r) { return r && r.price != null && !isNaN(parseFloat(r.price)); });
    // 1 opção = type + value + nome, ordenado da mais barata p/ a mais cara.
    var options = rates.map(function (r) {
      return {
        shipping_name: r.name,
        shipping_type: shippingType(r.name, r.source),
        shipping_value: Math.round(parseFloat(r.price) * 100) / 100
      };
    }).sort(function (a, b) { return a.shipping_value - b.shipping_value; });
    var local = ['Brasil', info.uf || '', info.city || ''].filter(Boolean).join('/');
    // dedupe do LOTE inteiro: evita re-disparar as N opções no mesmo cálculo (clique repetido)
    var batchSig = info.zip + '|' + options.map(function (o) { return o.shipping_type + ':' + o.shipping_value; }).join(',');
    var now = Date.now();
    if (batchSig === _shipSig && (now - _shipT) < 2500) return;
    _shipSig = batchSig; _shipT = now;

    // Totais da sacola via /cart.js — vão em TODOS os eventos do lote.
    function fireAll(cart) {
      var base = { shipping_zip: info.zip, shipping_local: local, shipping_options_count: options.length };
      // produto = cotou só o produto da PDP · sacola = cotou a sacola inteira (drawer, /cart ou fallback da PDP)
      base.shipping_context = info.context || 'sacola';
      // Dono (01/out): CADA evento leva a lista COMPLETA do que foi ofertado, pra uma
      // linha só no BigQuery dizer o que o cliente viu. "SEDEX:15.64|Uber:22.70|…"
      // (mais barata → mais cara), tipos distintos e a mais barata.
      if (options.length) {
        // Rótulo CURTO: o GA4 corta parâmetro em 100 caracteres e "Entrega expressa (Uber) ·
        // amanhã até meio-dia" sozinho comia metade. O nome completo segue em shipping_name.
        var curto = function (o) {
          if (o.shipping_type === 'entrega_expressa') return 'Uber';
          if (o.shipping_type === 'retirada_loja') return 'Retirada';
          if (o.shipping_type === 'entrega_local_poa') return /gr[aá]tis/i.test(o.shipping_name) ? 'Frete gratis' : 'Grandes Cargas';
          return o.shipping_name;
        };
        base.shipping_options = options.map(function (o) { return curto(o) + ':' + o.shipping_value.toFixed(2); }).join('|').slice(0, 100);
        base.shipping_types = options.map(function (o) { return o.shipping_type; })
          .filter(function (t, i, a) { return a.indexOf(t) === i; }).join(',');
        base.shipping_min_value = options[0].shipping_value;
      } else {
        base.shipping_options = ''; base.shipping_types = 'sem_opcao'; base.shipping_min_value = 0;
      }
      if (info.bairro) base.shipping_neighborhood = info.bairro;           // só se disponível
      if (cart) {
        base.shipping_products = cart.item_count;                          // qtd total de itens
        base.shipping_cart_total = Math.round(cart.total_price) / 100;     // BRL
        if (cart.total_weight) base.shipping_cart_weight = Math.round(cart.total_weight / 10) / 100; // g → kg
        // Detalhe por item (array p/ o GTM; GA4 não lê array de objetos em evento custom).
        // item_weight = peso da LINHA em kg (grams unitário × qtd); item_total = total da linha em BRL.
        base.shipping_items = (cart.items || []).map(function (it) {
          var qty = it.quantity || 1;
          var node = {
            item_sku: it.sku || String(it.product_id || it.id || ''),
            item_name: it.product_title || it.title || '',
            quantity: qty,
            item_total: Math.round((it.final_line_price != null ? it.final_line_price : it.line_price) || 0) / 100
          };
          if (it.grams != null) node.item_weight = Math.round(it.grams * qty / 10) / 100; // g → kg (linha)
          return node;
        });
      }
      if (!options.length) {   // região resolvida mas sem cotação
        window.dataLayer.push(_merge(base, {
          event: 'view_shipping_info', shipping_type: 'sem_opcao',
          shipping_value: 0, shipping_name: '', shipping_index: 0
        }));
        return;
      }
      options.forEach(function (o, i) {                                    // 1 evento por opção
        window.dataLayer.push(_merge(base, {
          event: 'view_shipping_info',
          shipping_type: o.shipping_type,
          shipping_value: o.shipping_value,
          shipping_name: o.shipping_name,
          shipping_index: i + 1                                           // 1 = mais barata
        }));
      });
    }
    // Cotação SÓ do produto da PDP: os totais vêm do que foi cotado (info.quoted), não
    // da sacola — que a essa altura já foi restaurada (vazia ou com outros itens).
    if (info.quoted) { fireAll(info.quoted); return; }
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(fireAll)
      .catch(function () { fireAll(null); });          // sem cart → dispara mesmo assim
  };

  // ── generate_lead — clique em QUALQUER link de WhatsApp (global) ──────
  // Cobre hero ("Falar com Especialista"), footer e o CTA de especialista, e
  // qualquer link wa.me futuro — sem tocar nas seções. lead_location = onde clicou.
  function leadLocation(el) {
    if (!el || !el.closest) return 'outro';
    // banner do carrossel da home com link de WhatsApp: diz QUAL banner (ex.: banner_master-colchoes-whatsapp)
    var bn = el.closest('a[data-banner-name]');
    if (bn) return 'banner_' + (bn.getAttribute('data-banner-name') || 'home').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    if (el.closest('.cima-hero')) return 'hero';
    if (el.closest('[class*="expert"]')) return 'expert_cta';
    if (el.closest('.cima-footer')) return 'footer';
    if (el.closest('.cima-header, .cima-nav, .cima-nav-mobile, .cima-announcement')) return 'header';
    if (el.closest('.cima-product, #cima-product, .cima-pdp')) return 'pdp';
    return 'outro';
  }
  var _leadH = '', _leadT = 0;
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (!/wa\.me|api\.whatsapp|whatsapp\.com|wa\.link/i.test(href)) return;
    var now = Date.now();
    if (href === _leadH && (now - _leadT) < 1000) return;   // anti duplo-clique
    _leadH = href; _leadT = now;
    window.dataLayer.push({
      event: 'generate_lead',
      lead_source: 'whatsapp',
      lead_location: leadLocation(a),
      link_url: href
    });
  }, true);

  // Busca o carrinho atual e executa cb(items, value, cart).
  function withCart(cb) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart.items || []).map(toItem);
        cb(items, money(cart.total_price), cart);
      })
      .catch(function () {});
  }

  // ── view_cart — ao abrir a Sacola (drawer) ──────────────────────────
  document.addEventListener('dispatch:cart-drawer:open', function () {
    withCart(function (items, value) {
      if (items.length) push('view_cart', items, value);
    });
  });

  // ── Captura de identificadores -> atributos do carrinho ─────────────
  //    Vão junto pro pedido (note_attributes) e o pipeline server-side usa:
  //    _ga_cid/_ga_sid = atribuição GA4; gclid/gbraid/wbraid = conversão
  //    OFFLINE no Google Ads (independe do GA4->Ads); fbclid = Meta (futuro).
  function readCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]+)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  // O clique do anúncio traz gclid/gbraid/wbraid na URL da LANDING (nem sempre o carrinho).
  // A Shopify descarta esses params, então persistimos em cookie 1st-party 90d aqui.
  function captureClickIds() {
    try {
      var qs = new URLSearchParams(location.search);
      ['gclid', 'gbraid', 'wbraid', 'fbclid'].forEach(function (k) {
        var v = qs.get(k);
        if (v) document.cookie = 'cima_' + k + '=' + encodeURIComponent(v)
          + ';path=/;max-age=7776000;SameSite=Lax';
      });
      // UTMs -> origem/mídia/campanha visíveis no PEDIDO (note_attributes).
      // Last-touch: uma nova utm_source sobrescreve o conjunto inteiro (não mistura campanha
      // velha com source nova). Sem utm na URL, mantém o que já está no cookie.
      var setUtm = function (src, med, camp) {
        var vals = { utm_source: src, utm_medium: med, utm_campaign: camp || '', utm_term: '', utm_content: '' };
        Object.keys(vals).forEach(function (k) {
          document.cookie = 'cima_' + k + '=' + encodeURIComponent(vals[k])
            + ';path=/;max-age=7776000;SameSite=Lax';
        });
      };
      if (qs.get('utm_source')) {
        ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(function (k) {
          var v = qs.get(k) || '';
          document.cookie = 'cima_' + k + '=' + encodeURIComponent(v)
            + ';path=/;max-age=7776000;SameSite=Lax';
        });
      } else if (qs.get('gclid') || qs.get('gbraid') || qs.get('wbraid')) {
        // Clique de anúncio SEM utm (Shopping/PMax não usam o template de URL): ~25% dos pedidos
        // vinham sem origem. Google Ads com click id = google / cpc.
        setUtm('google', 'cpc', '');
      } else if (qs.get('srsltid')) {
        // srsltid SEM gclid = listagem GRATUITA do Google Merchant (clique pago sempre traz gclid).
        setUtm('google', 'organic', 'shopping_gratuito');
      } else if (!readCookie('cima_utm_source') && document.referrer) {
        // Primeira visita sem campanha: origem pelo referrer externo (busca orgânica ou site).
        try {
          var rh = new URL(document.referrer).hostname.replace(/^www\./, '');
          if (rh && !/(cimafer\.com\.br|shopify|shop\.app|mercadopago|mercadolibre|mercadolivre)/.test(rh)) {
            var se = rh.match(/(google|bing|yahoo|duckduckgo|ecosia|yandex)\./);
            setUtm(se ? se[1] : rh, se ? 'organic' : 'referral', '');
          }
        } catch (e2) {}
      }
    } catch (e) {}
  }
  captureClickIds();

  function gaCookies() {
    var out = {};
    var m = document.cookie.match(/(?:^|;\s*)_ga=GA\d\.\d\.([\d.]+)/);
    if (m) out._ga_cid = m[1];
    // Cookie de sessao do GA4: formato ANTIGO `GS1.1.<sid>.` E NOVO `GS2.2.s<sid>$...`
    // (o GA4 migrou p/ o prefixo `s` + delimitador `$` — a regex antiga `GS\d.\d.(\d+)`
    //  parava no `s` e devolvia vazio -> session_id nunca ia pro pedido -> compra virava (direct)).
    var s = document.cookie.match(/(?:^|;\s*)_ga_[A-Z0-9]+=GS\d+\.\d+\.s?(\d{6,})/);
    if (s) out._ga_sid = s[1];
    // Identificadores de clique persistidos (p/ conversao offline no Ads/Meta).
    var g = readCookie('cima_gclid'); if (g) out._gclid = g;
    var gb = readCookie('cima_gbraid'); if (gb) out._gbraid = gb;
    var wb = readCookie('cima_wbraid'); if (wb) out._wbraid = wb;
    var fb = readCookie('cima_fbclid'); if (fb) out._fbclid = fb;
    // Origem/mídia/campanha (UTMs da última campanha) -> aparecem no pedido no Admin.
    var us = readCookie('cima_utm_source'); if (us) out.origem = us;
    var um = readCookie('cima_utm_medium'); if (um) out.midia = um;
    var uc = readCookie('cima_utm_campaign'); if (uc) out.campanha = uc;
    var ut = readCookie('cima_utm_term'); if (ut) out.termo = ut;
    var uo = readCookie('cima_utm_content'); if (uo) out.conteudo = uo;
    return out;
  }
  var _gaStamped = false;
  function stampGA() {
    if (_gaStamped) return;
    var c = gaCookies();
    // Carimba se houver QUALQUER identificador util (nao so o cid): um clique de anuncio
    // sem cookie _ga ainda precisa levar o gclid pro pedido.
    if (!c._ga_cid && !c._gclid && !c._gbraid && !c._wbraid) return;
    _gaStamped = true;
    try {
      window.fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: c }),
        keepalive: true
      })['catch'](function () { _gaStamped = false; });
    } catch (e) { _gaStamped = false; }
  }

  // Carimba já no carregamento (nao só no add/checkout): o _ga/_ga_<id> só aparecem
  // depois do gtag rodar, então tentamos algumas vezes. Reexecuta a cada pageview, então
  // se o cliente voltar numa nova sessão, o session_id do pedido reflete a sessão atual.
  function stampSoon() {
    var tries = 0;
    (function tick() {
      if (_gaStamped) return;
      stampGA();
      if (_gaStamped || ++tries >= 6) return;
      window.setTimeout(tick, 1500);
    })();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stampSoon);
  } else { stampSoon(); }

  // ── begin_checkout — TODO caminho de entrada no checkout ────────────
  // Helper global com dedupe: o "Comprar agora" da PDP pula o carrinho e navega
  // direto pro /checkout — sem isto, comprador desse caminho nunca dispara
  // begin_checkout e o funil fechado do GA4 zera no fim (visto no BQ 10/ago:
  // 5 de 8 compradores reais sem o evento). Retorna Promise pro chamador poder
  // aguardar o push antes de navegar; timeout de 1,2s pra NUNCA segurar a compra.
  var _bcLast = 0;
  window.cimaBeginCheckout = function () {
    return new Promise(function (resolve) {
      var now = Date.now();
      if (now - _bcLast < 1500) return resolve();   // clique duplo / caminho já coberto
      _bcLast = now;
      stampGA();
      var done = false;
      function fim() { if (!done) { done = true; resolve(); } }
      withCart(function (items, value) {
        if (items.length) push('begin_checkout', items, value);
        fim();
      });
      window.setTimeout(fim, 1200);
    });
  };
  document.addEventListener('click', function (e) {
    var btn = e.target.closest(
      'button[name="checkout"], .cart-drawer__summary .btn--primary[type="submit"], .cart__checkout-button, a[href^="/checkout"]'
    );
    if (!btn) return;
    window.cimaBeginCheckout();
  }, true);

  // ── remove_from_cart — clique na lixeira de um item da Sacola ───────
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('.cart-item__remove, .js-remove-item');
    if (!rm) return;
    var row = rm.closest('[data-variant-id], [id^="cart-item-"]');
    if (!row) return;
    var variantId = row.getAttribute('data-variant-id');
    var productId = row.getAttribute('data-product-id');
    // Captura os detalhes ANTES da remoção (o carrinho muda em seguida).
    withCart(function (items, value, cart) {
      var match = (cart.items || []).filter(function (l) {
        return String(l.variant_id) === String(variantId) ||
               String(l.product_id) === String(productId);
      });
      if (match.length) push('remove_from_cart', match.map(toItem), undefined);
    });
  }, true);

  // ── add_to_cart — intercepta /cart/add.js (centralizado, sem editar
  //    cada botão de adicionar) ──────────────────────────────────────
  var _fetch = window.fetch;
  if (typeof _fetch === 'function') {
    window.fetch = function () {
      var args = arguments;
      var input = args[0];
      var url = (input && input.url) ? input.url : (typeof input === 'string' ? input : '');
      var promise = _fetch.apply(this, args);
      // cima_restore=1 = re-adicao automatica do cima-cart-keeper, nao e acao do cliente
      if (typeof url === 'string' && url.indexOf('/cart/add') !== -1 && url.indexOf('cima_restore=1') === -1) {
        promise.then(function (res) {
          if (!res || !res.ok) return;
          res.clone().json().then(function (data) {
            var lines = data.items || [data];
            var items = lines.map(toItem);
            // Atribuição de lista: contexto carimbado no clique do card (window.__cimaAddCtx)
            var ctx = window.__cimaAddCtx;
            if (ctx) {
              items.forEach(function (it) {
                if (ctx.item_list_id) it.item_list_id = ctx.item_list_id;
                if (ctx.item_list_name) it.item_list_name = ctx.item_list_name;
                if (ctx.affiliation && !it.affiliation) it.affiliation = ctx.affiliation;
                if (ctx.discount != null && it.discount == null) it.discount = ctx.discount;
              });
            }
            window.__cimaAddCtx = null;
            var value = items.reduce(function (s, it) {
              return s + (it.price || 0) * (it.quantity || 1);
            }, 0);
            if (items.length) push('add_to_cart', items, value);
            stampGA();
          }).catch(function () {});
        }).catch(function () {});
      }
      return promise;
    };
  }
})();

/* =====================================================================
   CIMAFER · dataLayer (parte 2) — listas de produtos
   view_item_list (impressions), select_item (clique no card),
   add_to_wishlist (favoritar) e carimbo de contexto p/ add_to_cart.
   Lê os itens GA4 de cada card via atributo data-ga-item (JSON) e a lista
   via data-ga-list / data-ga-list-id / data-ga-list-name no container.
   ===================================================================== */
(function () {
  window.dataLayer = window.dataLayer || [];
  var CURRENCY = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'BRL';
  var WKEY = 'cima:wishlist';

  function push(event, ecommerce) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({ event: event, ecommerce: ecommerce });
  }
  function parseItem(el) {
    if (!el) return null;
    try { return JSON.parse(el.getAttribute('data-ga-item')); } catch (e) { return null; }
  }
  function listCtx(listEl) {
    return {
      item_list_id: listEl ? (listEl.getAttribute('data-ga-list-id') || '') : '',
      item_list_name: listEl ? (listEl.getAttribute('data-ga-list-name') || '') : '',
      affiliation: listEl ? (listEl.getAttribute('data-ga-affiliation') || '') : ''
    };
  }
  function itemsOf(listEl) {
    var cards = listEl.querySelectorAll('[data-ga-item]');
    var ctx = listCtx(listEl);
    var out = [];
    for (var i = 0; i < cards.length; i++) {
      var it = parseItem(cards[i]);
      if (!it) continue;
      it.index = i + 1;
      it.item_list_id = ctx.item_list_id;
      it.item_list_name = ctx.item_list_name;
      if (ctx.affiliation) it.affiliation = ctx.affiliation;
      out.push(it);
    }
    return out;
  }

  // ── view_item_list (impressions) — uma vez por lista, ao entrar na viewport ──
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      var listEl = en.target;
      io.unobserve(listEl);
      var items = itemsOf(listEl);
      if (items.length) push('view_item_list', { item_list_id: items[0].item_list_id, item_list_name: items[0].item_list_name, items: items });
    });
  }, { threshold: 0.2 }) : null;

  var seen = (typeof WeakSet === 'function') ? new WeakSet() : null;
  function observeLists() {
    var lists = document.querySelectorAll('[data-ga-list]');
    for (var i = 0; i < lists.length; i++) {
      var l = lists[i];
      if (seen && seen.has(l)) continue;
      if (seen) seen.add(l);
      if (!l.querySelector('[data-ga-item]')) { if (seen) seen.delete(l); continue; } // lista ainda vazia (AJAX) — tenta depois
      // Listas "eager" (grade de categoria/busca = conteúdo principal da página) disparam
      // a impressão NO LOAD, sem esperar scroll. As demais (carrosséis da home) seguem por viewport.
      if (io && !l.hasAttribute('data-ga-eager')) {
        io.observe(l);
      } else {
        var items = itemsOf(l);
        if (items.length) push('view_item_list', { item_list_id: items[0].item_list_id, item_list_name: items[0].item_list_name, items: items });
      }
    }
  }

  // ── select_item — clique no card (ignora coração e botão de adicionar) ──
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cima-fav]') || e.target.closest('[data-cima-cart-add]') || e.target.closest('.cima-card-produto__btn-add')) return;
    var card = e.target.closest('[data-ga-item]');
    if (!card) return;
    var listEl = card.closest('[data-ga-list]');
    var item = parseItem(card);
    if (!item) return;
    var ctx = listCtx(listEl);
    item.item_list_id = ctx.item_list_id;
    item.item_list_name = ctx.item_list_name;
    if (ctx.affiliation) item.affiliation = ctx.affiliation;
    var sibs = listEl ? listEl.querySelectorAll('[data-ga-item]') : [card];
    item.index = Array.prototype.indexOf.call(sibs, card) + 1;
    push('select_item', { item_list_id: ctx.item_list_id, item_list_name: ctx.item_list_name, items: [item] });
  });

  // ── add_to_cart: carimba o contexto da lista no submit, p/ o interceptor de /cart/add ler ──
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cima-cart-add]');
    if (!form) return;
    var card = form.closest('[data-ga-item]');
    var item = parseItem(card);
    if (item) {
      var ctx = listCtx(form.closest('[data-ga-list]'));
      window.__cimaAddCtx = { item_list_id: ctx.item_list_id, item_list_name: ctx.item_list_name, affiliation: ctx.affiliation || item.affiliation, discount: item.discount };
    } else {
      window.__cimaAddCtx = null;
    }
  }, true);

  // ── add_to_wishlist — dispara só ao FAVORITAR (não ao remover) ──
  function wishlist() { try { var a = JSON.parse(localStorage.getItem(WKEY) || '[]'); return Array.isArray(a) ? a.map(String) : []; } catch (e) { return []; } }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cima-fav]');
    if (!btn) return;
    var handle = String(btn.dataset.productHandle || '');
    if (!handle) return;
    var item = parseItem(btn.closest('[data-ga-item]'));
    // Lê o estado DEPOIS de o handler do header togglar (próximo tick).
    setTimeout(function () {
      if (wishlist().indexOf(handle) === -1) return; // foi remoção → não dispara
      if (!item) item = { item_name: handle };
      push('add_to_wishlist', { currency: CURRENCY, value: item.price, items: [item] });
    }, 0);
  });

  // Observa as listas presentes no load e as inseridas via AJAX (recomendados, vistos).
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeLists);
  else observeLists();
  document.addEventListener('cima:recs:rendered', observeLists);
})();

/* =====================================================================
   CIMAFER · dataLayer (parte 3) — view_search_results (evento padrão GA4)
   Dispara `view_search_results` com `search_term` na página de resultados
   (/search?q=). Dedupe por sessionStorage p/ não refirear em reload de
   filtro/paginação (mesmo termo). NÃO é evento de ecommerce (a impressão
   dos itens da busca já vai pelo `view_item_list` da grade .cima-search__grid).
   ===================================================================== */
(function () {
  window.dataLayer = window.dataLayer || [];
  // SKUs dos 6 primeiros cards da grade, na ordem em que o cliente VÊ (depois do
  // top-up reordenar). O card já carrega o item do GA4 em data-ga-item; daqui sai só
  // o sku, de propósito — o resto se resolve por matching no Shopify depois.
  function topSkus(n) {
    var out = [];
    var cards = document.querySelectorAll('.cima-search__grid [data-ga-item]');
    for (var i = 0; i < cards.length && out.length < n; i++) {
      try {
        var it = JSON.parse(cards[i].getAttribute('data-ga-item'));
        if (it && it.sku) out.push(String(it.sku));
      } catch (e) {}
    }
    return out;
  }

  function fireSearch() {
    if (window.location.pathname.indexOf('/search') === -1) return;
    // A seção cima-search publica window.cimaSearchMeta com o termo HUMANO e a
    // contagem de resultados (só o Liquid enxerga search.results_count).
    // Fallback: a query da URL, que vem estrita (" AND ") — limpa antes de mandar.
    var meta = window.cimaSearchMeta || null;
    var term = '';
    var count = null;
    if (meta && meta.term) {
      term = String(meta.term).trim();
      count = typeof meta.count === 'number' ? meta.count : null;
    } else {
      try { term = (new URLSearchParams(window.location.search).get('q') || '').trim(); } catch (e) { return; }
      term = term.replace(/ AND /g, ' ').trim();
    }
    if (!term) return;
    var chave = term + '|' + count;
    try {
      if (sessionStorage.getItem('cima:lastSearch') === chave) return; // mesmo termo (filtro/paginação)
      sessionStorage.setItem('cima:lastSearch', chave);
    } catch (e) {}
    var payload = { event: 'view_search_results', search_term: term };
    if (count !== null) {
      payload.search_results_count = count;
      payload.search_zero_results = count === 0;   // a métrica que diz se a busca falhou
      if (meta && meta.relaxed) payload.search_relaxed = true;
    }
    topSkus(6).forEach(function (sku, i) { payload['product' + (i + 1)] = sku; });
    window.dataLayer.push(payload);
  }

  // espera a grade assentar (o top-up reordena via fetch) para não gravar a ordem errada;
  // 1500 ms é o teto — sem resultados ou a partir da pág. 2 o evento nunca vem.
  function fireSearchQuandoAGradeAssentar() {
    if (window.location.pathname.indexOf('/search') === -1) return;
    var jaFoi = false;
    var vai = function () { if (jaFoi) return; jaFoi = true; fireSearch(); };
    document.addEventListener('cima:search-grid-ready', vai, { once: true });
    setTimeout(vai, 1500);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fireSearchQuandoAGradeAssentar);
  } else {
    fireSearchQuandoAGradeAssentar();
  }
})();
